
namespace GeniuzPOS.ReportMasterData {

    @Serenity.Decorators.registerClass()
    export class Report_1406Dialog extends Serenity.EntityDialog<Report_1406Row, any> {
        protected getFormKey() { return Report_1406Form.formKey; }
        protected getIdProperty() { return Report_1406Row.idProperty; }
        protected getLocalTextPrefix() { return Report_1406Row.localTextPrefix; }
        protected getNameProperty() { return Report_1406Row.nameProperty; }
        protected getService() { return Report_1406Service.baseUrl; }
        protected getDeletePermission() { return Report_1406Row.deletePermission; }
        protected getInsertPermission() { return Report_1406Row.insertPermission; }
        protected getUpdatePermission() { return Report_1406Row.updatePermission; }

        protected form = new Report_1406Form(this.idPrefix);

    }
}